import { render, staticRenderFns } from "./follow-user.vue?vue&type=template&id=34ec3e38&"
import script from "./follow-user.vue?vue&type=script&lang=js&"
export * from "./follow-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports